import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const expandableTextBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "Expandable Text",
    shouldReceiveBuilderProps: {
      builderBlock: true,
      builderComponents: true,
      builderLinkComponent: true,
    },
    canHaveChildren: true,
    inputs: [
      {
        name: "viewMore",
        type: "string",
        required: false,
        localized: true,
      },
      {
        name: "viewLess",
        type: "string",
        required: false,
        localized: true,
      },
      {
        name: "linesToShow",
        type: "number",
        defaultValue: 3,
        required: true,
        localized: false,
        helperText: "Number of lines to show before truncation",
      },
      {
        name: "expandTo",
        type: "select",
        enum: ["top", "bottom"],
        defaultValue: "top",
        localized: false,
        helperText: "Direction to expand the text from the button.",
      },
      { ...DLD_FIELD, required: false },
      { ...DLT_FIELD, required: false },
    ],
    childRequirements: {
      message: "This block can have only Text children.",
      query: {
        "component.name": { $in: ["Text"] },
      },
    },
    defaultChildren: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "Text",
          options: {
            text: "Add your content here. This text will be expandable based on the character limit you set.",
          },
        },
      },
    ],
    defaultStyles: {
      width: "100%",
      color: "var(--color-swdc-gray-400)",
    },
  };
